module.exports = __webpack_public_path__ + "img/BTDX.069846c3.svg";